/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";

import { formatDate } from "../../../helpers/date";

import ResponsiveDataComponent from "../../common/ResponsiveDataComponent";
import Badge from "../../common/Badge";

const AuditLogList = ({ isMobile, data = [] }) => {
  const columns = !isMobile
    ? [
        {
          Header: "Action",
          accessor: "action.label",
          maxWidth: 180,
          Cell: ({ original, value }) => (
            <Badge color={original.action?.color}>{value}</Badge>
          )
        },
        {
          Header: "Created Date",
          accessor: "created_on",
          maxWidth: 240,
          Cell: ({ value }) => (
            <span>
              {formatDate(value, "MMM dd, yyyy")}
              <br />
              {formatDate(value, "hh:mm a")}
            </span>
          )
        },
        {
          Header: "User",
          accessor: "user.full_name",
          maxWidth: 240,
          Cell: (row) => <span>{row?.value}</span>
        },
        {
          Header: "Note",
          accessor: "note",
          Cell: ({ value }) => (
            <div style={{ whiteSpace: "pre-wrap" }}>{value}</div>
          )
        }
      ]
    : [
        {
          Header: "User",
          accessor: "user.full_name",
          style: { textAlign: "center" },
          maxWidth: 80
        },
        {
          Header: "Action",
          accessor: "action.label",
          style: { textAlign: "center" },
          maxWidth: 180,
          Cell: (row) => (
            <Badge color={row?.value?.color}>{row?.value?.label}</Badge>
          )
        }
      ];

  return (
    <ReactTable
      className="-highlight audit"
      data={data}
      columns={columns}
      showPageSizeOptions={!isMobile}
      defaultPageSize={5}
      showPagination={data.length > 5}
      defaultSorted={[
        {
          id: "created_on",
          desc: true
        }
      ]}
      SubComponent={
        isMobile
          ? ({ original }) => (
              <ResponsiveDataComponent
                data={[
                  {
                    key: "User",
                    label: original.user.full_name
                  },
                  { key: "Action", label: original.action.color }
                ]}
              />
            )
          : false
      }
    />
  );
};

AuditLogList.propTypes = {
  data: PropTypes.array,
  isMobile: PropTypes.bool
};

export default AuditLogList;
